import type { FC } from 'react'

import styled from 'styled-components'

import { StyledSyncLoader } from './StyledSyncLoader'

const StyledAbsoluteCenter = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const CenteredLoader: FC = () => (
  <StyledAbsoluteCenter>
    <StyledSyncLoader />
  </StyledAbsoluteCenter>
)
